<!-- add-leadership-role.component.html -->
<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white">
      <h5 class="mb-0">Add Leadership Role</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="leadershipForm" (ngSubmit)="submitForm()">
        <div class="mb-3">
          <label for="leadershipName" class="form-label">Leadership Role Name</label>
          <input
            type="text"
            class="form-control"
            id="leadershipName"
            formControlName="leadershipName"
            placeholder="e.g. Senior Pastor"
          />
        </div>

        <div class="mb-3">
          <label for="postedBy" class="form-label">Posted By</label>
          <input
            type="text"
            class="form-control"
            id="postedBy"
            formControlName="postedBy"
            placeholder="e.g. admin@example.com"
          />
        </div>

        <button
          type="submit"
          class="btn btn-success"
          [disabled]="loading || leadershipForm.invalid"
        >
          {{ loading ? 'Submitting...' : 'Submit' }}
        </button>
      </form>
    </div>
  </div>
</div>

